///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'sui-svg-icon[windeGreen]',
    standalone: false
})
export class GreenActionIconDirective {
    @HostBinding('class') buttonClass = 'winde-svg-action-icon winde-green-icon';

    @HostBinding('style.width') width = '1em';
    @HostBinding('style.height') height = '1em';
}
